import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * Format les montants poru avoir le $ du bon côté selon la langue locale
 * Fix aussi le bug avec les décimales
  */

@Pipe({
  name: 'dollarSignByLocal'
})

export class dollarSignByLocalPipe implements PipeTransform {

  constructor(
    private translateService: TranslateService,
  ) {}

  transform(value: any, showZero?: boolean): string {
    let local = this.translateService.currentLang.toLowerCase();

    // on affiche rien si la valeur est nulle/indéfinie/vide
    if (value === null || value === undefined || value === '') {
      if (showZero)
        return local === 'en' ? '$0.00' : '0,00$';
      else
        return '';
    }

    if(value === "Infinity") {
      return 'N/A'
    }

    value = parseFloat(value).toFixed(2);
    
    if (local === 'en') {
      return `$${value}`;
    } else {
      return `${value}$`.replace('.', ',');
    }
  }

}